import React from 'react';

import { cn } from '@easydatasolution/ui-react/lib/utils';
import GoogleReCAPTCHA from 'react-google-recaptcha';

type ReCAPTCHAProps = {
	showError: boolean;
	setIsCompleted: (value: boolean) => void;
	className?: string;
};

export const ReCAPTCHA = React.forwardRef<GoogleReCAPTCHA, ReCAPTCHAProps>(
	({ showError, setIsCompleted, className }, ref) => (
		<div
			className={cn(
				'h-[80px] w-[306px] rounded-[3px] border-2 border-transparent',
				showError && 'border-red-500',
				className,
			)}
		>
			<GoogleReCAPTCHA
				ref={ref}
				sitekey={process.env.GATSBY_RECAPTCHA_SITE_KEY}
				hl="de"
				onChange={() => {
					setIsCompleted(true);
				}}
				onExpired={() => {
					setIsCompleted(false);
				}}
				onErrored={() => {
					setIsCompleted(false);
				}}
				style={{ width: '304px', height: '78px' }}
			/>
		</div>
	),
);
